import { http } from "src/common/http";
import { CouponParam } from "src/module/coupon/param/coupon.param";

class PopupActivityService {
	list = async (param?: CouponParam) => {
		return http({
			url: process.env.REACT_APP_GO_API + "/api/v1/admin/popup-configs",
			method: "GET",
			params: param,
		});
	};
	detail = async (id: number) => {
		return http({
			url: process.env.REACT_APP_GO_API + "/api/v1/admin/popup-configs/" + id,
			method: "GET",
		});
	};
	delete = async (id: number) => {
		return http({
			url: process.env.REACT_APP_GO_API + "/api/v1/admin/popup-configs/" + id,
			method: "DELETE",
		});
	};
	update = async (id: number, param: CouponParam) => {
		return http({
			url: process.env.REACT_APP_GO_API + "/api/v1/admin/popup-configs/" + id,
			method: "PUT",
			data: param,
		});
	};
	add = async (param: CouponParam) => {
		return http({
			url: process.env.REACT_APP_GO_API + "/api/v1/admin/popup-configs",
			method: "POST",
			data: param,
		});
	};
	record = async (param?: CouponParam) => {
		return http({
			url: process.env.REACT_APP_GO_API + "/api/v1/admin/popup-records",
			method: "GET",
			params: param,
		});
	};
}
export default new PopupActivityService();
